var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-container',{attrs:{"fluid":""}},[_c('div',{attrs:{"clas":"row pa-0 ma-0"}},[_c('div',{staticClass:"col-12"},[_c('v-card',{attrs:{"tile":"","flat":"","color":"transparent"}},[_c('router-view')],1)],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }